export class DateHelper {

  constructor(private _moment) {}

  public get(dateString) {
    return this._moment(dateString)
  }

  public formatTime(timeInSeconds: number, showHours: boolean = true): string {
    let timeString = ''
    const hours = this._padNumber(Math.floor(timeInSeconds / 60 / 60))
    const minutes = this._padNumber(Math.floor(timeInSeconds / 60 % 60))
    const seconds = this._padNumber(Math.floor(timeInSeconds % 60))

    if (showHours) {
      timeString = `${hours}:`
    }

    return `${timeString}${minutes}:${seconds}`
  }

  private _padNumber(digit: number): string {
    return digit >= 10 ? `${digit}` : `0${digit}`
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/date-helper/date-helper.ts